// extracted by mini-css-extract-plugin
export default {"wrapper":"social-linkpost-upload-LinkPostUploader__wrapper--nYJ9D"};